import React  from "react";
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

import imagem from '../../assets/logo512.png';

export default function Logo({ version }) {

  return (
    <>
      <Link
        href="/"
        sx={{
          display: 'block',
          textAlign: 'left',
        }}>
        <img
          className="img-logo"
          src={imagem}
          alt="Logo"
        />
      </Link>

      <Typography
        variant="h5"
        sx={{
          flexGrow: { xs: 1, sm: 0 },
          fontFamily: 'Merriweather, serif',
          color: '#faf0e8',
        }}>
          Entrevista Inicial
      </Typography>

      <Typography
        sx={{
          fontSize: 10,
          marginLeft: 1,
          marginTop: 1,
          display: { xs: 'none', sm: 'inline' },
          flexGrow: 1,
        }}>
          {version}
      </Typography>
    </>
  );
}
